// ==================================================
// IMPORTS
// ==================================================
import React from "react";
import { Home, RefreshCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./PageQuickNav.css";

// ==================================================
// PAGE QUICK NAV COMPONENT
//
// Purpose:
// Provides reusable page-level navigation
// controls throughout Kuddlecore.
//
// Examples:
// Home Button
// Refresh Button
// Future Back Button
// Future Print Button
//
// ==================================================

const PageQuickNav = ({
    showHome = true,
    showRefresh = false,
    onRefresh,
    refreshing = false,
}) => {

    // ==================================================
    // ROUTING
    // ==================================================
    const navigate = useNavigate();

    // ==================================================
    // RENDER UI
    // ==================================================
    return (
        <div className="page-quick-nav">
            {/* HOME BUTTON */}
            {showHome && (
                <button
                    type="button"
                    className="page-quick-nav-btn"
                    onClick={() => navigate("/")}
                >
                    <span className="page-quick-nav-icon">
                        <Home size={22} />
                    </span>
                    <span>Home</span>
                </button>
            )}

            {/* REFRESH BUTTON */}

            {showRefresh && (
                <button
                    type="button"
                    className="page-quick-nav-btn"
                    onClick={onRefresh}
                    disabled={refreshing}
                >
                    <RefreshCcw
                        size={24}
                        className={refreshing ? "spin-icon" : ""}
                    />
                    <span>Refresh</span>
                </button>
            )}
        </div>
    );
};

export default PageQuickNav;